import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Ashley R.',
  location: 'Austin, TX'
}, {
  name: 'Jessica M.',
  location: 'Denver, CO'
}, {
  name: 'Emily T.',
  location: 'Portland, OR'
}, {
  name: 'Sophia K.',
  location: 'Nashville, TN'
}, {
  name: 'Olivia B.',
  location: 'Scottsdale, AZ'
}, {
  name: 'Chloe S.',
  location: 'San Diego, CA'
}, {
  name: 'Mia L.',
  location: 'Miami, FL'
}, {
  name: 'Isabella C.',
  location: 'Seattle, WA'
}, {
  name: 'Madison P.',
  location: 'Charlotte, NC'
}, {
  name: 'Grace W.',
  location: 'Minneapolis, MN'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showPopup, 15000);
    setTimeout(showPopup, 3000);
    return () => clearInterval(interval);
  }, []);
  return <>
      {visible && <div className="fixed bottom-4 left-4 z-50 animate-slide-in" data-id="element-201">
          <div className="bg-white border-2 border-brand-gold shadow-2xl rounded-lg p-3 pr-8 max-w-[260px] relative overflow-hidden ring-2 ring-brand-petrol/30" data-id="element-202">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-brand-petrol via-brand-gold to-brand-petrol" data-id="element-203"></div>
            <button onClick={() => setVisible(false)} className="absolute top-1.5 right-1.5 text-gray-400 hover:text-brand-graphite transition-colors" data-id="element-204">
              <XIcon className="w-3.5 h-3.5" data-id="element-205" />
            </button>
            <div className="flex items-center gap-3" data-id="element-206">
              <div className="w-9 h-9 rounded-full bg-brand-gold/15 flex items-center justify-center shrink-0 border border-brand-gold/40" data-id="element-207">
                <ShoppingBag className="w-4.5 h-4.5 text-brand-gold" data-id="element-208" />
              </div>
              <div className="leading-tight" data-id="element-209">
                <p className="font-bold text-brand-graphite text-sm" data-id="element-210">
                  {currentPurchase.name}
                </p>
                <p className="text-[11px] text-gray-500 font-medium" data-id="element-211">
                  {currentPurchase.location}
                </p>
                <p className="text-xs text-brand-petrol font-bold mt-0.5" data-id="element-212">
                  just purchased NUTRITIONIST PRO™
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>;
}